<template>
  <th scope="col" class="p-3 border-b text-color-4 text-left whitespace-nowrap border-gray-200 dark:border-gray-700">
    <slot></slot>
  </th>
</template>

<script>
export default {
  name: 'TableHeadCell'
}
</script>
